import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '100vh', padding: '24px',
          background: '#12373f', color: '#fff', textAlign: 'center',
          fontFamily: 'Arial, sans-serif',
        }}>
          <h2 style={{ marginBottom: '12px', fontSize: '20px' }}>
            Something went wrong
          </h2>
          <p style={{ marginBottom: '20px', fontSize: '14px', opacity: 0.8 }}>
            Please try refreshing the page.
          </p>
          <button
            onClick={this.handleRetry}
            style={{
              background: '#911efd', color: '#fff', border: 'none',
              padding: '10px 28px', borderRadius: '6px', fontSize: '14px',
              cursor: 'pointer',
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
